import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {sellProduct} from "../AC/sell-product";
import {saveDesign} from "../AC/save-design";
import MobileCtx from "../../../contexts/MobileCtx";
import withErrorBoundary from "../decorators/withErrorBoundary";
import NoSsr from "@material-ui/core/NoSsr";
import SaveIcon from "@material-ui/icons/SaveOutlined";
import MoneyIcon from "@material-ui/icons/AttachMoneyOutlined";
import {Tooltip} from "@material-ui/core";
import Order from "./Order";
import {mobileAppSelector, onPlatformSelector} from "../selectors";

export class ActionPanel extends PureComponent {
  static propTypes = {
    isOwner: PropTypes.bool,
    sellProduct: PropTypes.func,
    saveDesign: PropTypes.func,
    classes: PropTypes.object,
    onPlatform: PropTypes.string,
    mobileApp: PropTypes.bool
  };

  render() {
    const {isOwner, onPlatform, mobileApp} = this.props;
    return (
      <div className="product-buttons">
        <MobileCtx.Consumer>
          {(isMobile) => (
            <NoSsr>
              <div className="product-buttons__order">
                <Order />
              </div>
              {!mobileApp && (
                <Tooltip title="Ctrl+S">
                  <button
                    variant="outlined"
                    onClick={this.props.saveDesign}
                    className="product-buttons__item product-buttons__item_save"
                  >
                    <SaveIcon />
                    Сохранить
                  </button>
                </Tooltip>
              )}
              {!isMobile && isOwner && onPlatform !== `vtb` && (
                <button
                  variant="outlined"
                  onClick={this.props.sellProduct}
                  className="product-buttons__item product-buttons__item_sell"
                >
                  <MoneyIcon />
                  На продажу
                </button>
              )}
            </NoSsr>
          )}
        </MobileCtx.Consumer>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    onPlatform: onPlatformSelector(state),
    mobileApp: mobileAppSelector(state)
  }),
  {
    sellProduct,
    saveDesign
  }
)(withErrorBoundary(ActionPanel));
